import { createSelector } from 'reselect';
import { RootState } from 'ReduxTypes';

export const selectSettings = (state: RootState) => state.settings;

export const selectBanner = createSelector(
  selectSettings,
  (settings) => settings.banners,
);
